@use './variables' as *;
@use '../../styles/abstracts' as *;

:host {
  display: $button-host-display;
  vertical-align: $button-host-vertical-align;
}

@mixin buttonVariantState($buttonColor, $buttonBackgroundColor, $buttonBorderColor) {
  color: $buttonColor;
  background-color: $buttonBackgroundColor;
  border-color: $buttonBorderColor;
}

@mixin buttonVariant(
  $buttonColor,
  $buttonBackgroundColor,
  $buttonBorderColor,
  $buttonHoverColor,
  $buttonHoverBackgroundColor,
  $buttonHoverBorderColor,
  $buttonFocusColor,
  $buttonFocusBackgroundColor,
  $buttonFocusBorderColor,
  $buttonActiveColor,
  $buttonActiveBackgroundColor,
  $buttonActiveBorderColor,
  $buttonDisabledColor,
  $buttonDisabledBackgroundColor,
  $buttonDisabledBorderColor
) {
  @include buttonVariantState($buttonColor, $buttonBackgroundColor, $buttonBorderColor);

  &:hover {
    @include buttonVariantState(
      $buttonHoverColor,
      $buttonHoverBackgroundColor,
      $buttonHoverBorderColor
    );
  }

  &:focus {
    @include buttonVariantState(
      $buttonFocusColor,
      $buttonFocusBackgroundColor,
      $buttonFocusBorderColor
    );
  }

  &:active {
    @include buttonVariantState(
      $buttonActiveColor,
      $buttonActiveBackgroundColor,
      $buttonActiveBorderColor
    );
  }

  &[disabled] {
    @include buttonVariantState(
      $buttonDisabledColor,
      $buttonDisabledBackgroundColor,
      $buttonDisabledBorderColor
    );
    cursor: default;
  }
}

.button {
  display: flex;
  justify-content: center;
  width: 100%;
  font-size: $button-font-size;
  font-weight: $button-font-weight;
  font-family: $button-font-family;
  line-height: $button-line-height;
  padding-top: $button-padding-top;
  padding-left: $button-padding-left;
  padding-bottom: $button-padding-bottom;
  padding-right: $button-padding-right;
  border-width: $button-border-width;
  border-style: $button-border-style;
  border-radius: $button-border-radius;
  cursor: pointer;
  margin: 0px;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 $button-focus-outline-width $button-focus-outline-color;
  }

  &-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    margin-top: $button-margin-top;
    margin-left: $button-margin-left;
    margin-bottom: $button-margin-bottom;
    margin-right: $button-margin-right;
    border-radius: $button-border-radius;
    box-shadow: $button-box-shadow;
  }

  &-primary {
    @include buttonVariant(
      $button-primary-color,
      $button-primary-background-color,
      $button-primary-border-color,
      $button-primary-hover-color,
      $button-primary-hover-background-color,
      $button-primary-hover-border-color,
      $button-primary-focus-color,
      $button-primary-focus-background-color,
      $button-primary-focus-border-color,
      $button-primary-active-color,
      $button-primary-active-background-color,
      $button-primary-active-border-color,
      $button-primary-disabled-color,
      $button-primary-disabled-background-color,
      $button-primary-disabled-border-color
    );
  }

  &-secondary {
    @include buttonVariant(
      $button-secondary-color,
      $button-secondary-background-color,
      $button-secondary-border-color,
      $button-secondary-hover-color,
      $button-secondary-hover-background-color,
      $button-secondary-hover-border-color,
      $button-secondary-focus-color,
      $button-secondary-focus-background-color,
      $button-secondary-focus-border-color,
      $button-secondary-active-color,
      $button-secondary-active-background-color,
      $button-secondary-active-border-color,
      $button-secondary-disabled-color,
      $button-secondary-disabled-background-color,
      $button-secondary-disabled-border-color
    );
  }

  &-tertiary {
    @include buttonVariant(
      $button-tertiary-color,
      $button-tertiary-background-color,
      $button-tertiary-border-color,
      $button-tertiary-hover-color,
      $button-tertiary-hover-background-color,
      $button-tertiary-hover-border-color,
      $button-tertiary-focus-color,
      $button-tertiary-focus-background-color,
      $button-tertiary-focus-border-color,
      $button-tertiary-active-color,
      $button-tertiary-active-background-color,
      $button-tertiary-active-border-color,
      $button-tertiary-disabled-color,
      $button-tertiary-disabled-background-color,
      $button-tertiary-disabled-border-color
    );
  }

  &-icon-placement {
    &-left {
      .button-icon {
        margin-right: $spacing-02;
      }
    }

    &-right {
      .button-icon {
        margin-left: $spacing-02;
      }
    }
  }

  &-progress-line {
    height: $button-progress-line-height;
    background-color: $button-progress-line-color;

    &-wrapper {
      width: 100%;
      position: absolute;
      overflow: hidden;
      border-top-left-radius: $button-border-radius;
      border-top-right-radius: $button-border-radius;
      top: 0;
      left: 0;
      z-index: 1;
    }
  }
}

@media (max-width: $breakpoint-mobile) {
  :host {
    display: $mobile-button-host-display;
    vertical-align: $mobile-button-host-vertical-align;
    width: $mobile-button-host-width;
  }

  .button {
    &-wrapper {
      margin-top: $mobile-button-margin-top;
      margin-left: $mobile-button-margin-left;
      margin-bottom: $mobile-button-margin-bottom;
      margin-right: $mobile-button-margin-right;
    }
  }
}
